export const getAnswerListStyle = isDraggingOver => ({
  background: isDraggingOver ? 'white' : 'white',
  padding: 0,
  //width: 250
})

export const getAiChatSubHeaderListStyle = isDraggingOver => ({
  background: isDraggingOver ? '#f4f4f4' : '#fff',
  padding: 0,
})
